// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Wrapper for phone number component (select + input)
 */
.phone-number-module__wrapper--IQeyY {
  display: flex;
  gap: 8px;
  width: 100%;
  align-items: flex-start;
}
/**
 * Dial code select styling
 */
.phone-number-module__dialCodeSelect--lwWi0 {
  flex-shrink: 0;
  width: 100px;
  min-width: 100px;
  max-width: 100px;
}
.phone-number-module__dialCodeSelect--lwWi0.phone-number-module__disabled--zpf6T {
  opacity: 0.6;
  pointer-events: none;
}
/**
 * Phone number input styling
 */
.phone-number-module__phoneInput--Qn9Ck {
  flex: 1;
  min-width: 0;
}
/**
 * Field wrappers (remove internal labels)
 */
.phone-number-module__selectField--GiTXg,
.phone-number-module__inputField--uD0tI {
  margin-bottom: 0;
}
/**
 * Dial code option in dropdown (search results)
 */
.phone-number-module__dialCodeOption--Te0rj {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.phone-number-module__flagImage--VS2Rg {
  width: 24px;
  height: auto;
  flex-shrink: 0;
}
.phone-number-module__countryName--cyt8P {
  flex: 1;
  font-size: 14px;
}
.phone-number-module__dialCodeText--oQpb6 {
  font-size: 13px;
  color: #8c8c8c;
  margin-left: auto;
}
/**
 * Dial code minimal (displayed in select box)
 */
.phone-number-module__dialCodeMinimal--vdJlY {
  display: flex;
  align-items: center;
  gap: 6px;
}
.phone-number-module__flagImageSmall--Ae2TD {
  width: 18px;
  height: auto;
  flex-shrink: 0;
}
.phone-number-module__dialCodeValue--Mw3_b {
  font-size: 14px;
  font-weight: 500;
}
/**
 * Responsive adjustments
 */
@media (max-width: 768px) {
  .phone-number-module__wrapper--IQeyY {
    flex-direction: column;
    gap: 12px;
  }
  .phone-number-module__dialCodeSelect--lwWi0 {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./components/atoms/forms/fields/phone-number/phone-number.module.less"],"names":[],"mappings":"AAAA;;EAEE;AAEF;EACE,aAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;AAAF;AACA;;EAEE;AAIF;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAFF;AAKA;EACE,YAAA;EACA,oBAAA;AAHF;AACA;;EAEE;AAOF;EACE,OAAA;EACA,YAAA;AALF;AACA;;EAEE;AASF;;EAEE,gBAAA;AAPF;AACA;;EAEE;AAWF;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AATF;AAYA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAVF;AAaA;EACE,OAAA;EACA,eAAA;AAXF;AAcA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAZF;AACA;;EAEE;AAgBF;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAdF;AAiBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAfF;AAkBA;EACE,eAAA;EACA,gBAAA;AAhBF;AACA;;EAEE;AAoBF;EACE;IACE,sBAAA;IACA,SAAA;EAlBF;EAqBA;IACE,WAAA;EAnBF;AACF","sourcesContent":["/**\n * Wrapper for phone number component (select + input)\n */\n\n.wrapper {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n  align-items: flex-start;\n}\n\n/**\n * Dial code select styling\n */\n\n.dialCodeSelect {\n  flex-shrink: 0;\n  width: 100px;\n  min-width: 100px;\n  max-width: 100px;\n}\n\n.dialCodeSelect.disabled {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n/**\n * Phone number input styling\n */\n\n.phoneInput {\n  flex: 1;\n  min-width: 0;\n}\n\n/**\n * Field wrappers (remove internal labels)\n */\n\n.selectField,\n.inputField {\n  margin-bottom: 0;\n}\n\n/**\n * Dial code option in dropdown (search results)\n */\n\n.dialCodeOption {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.flagImage {\n  width: 24px;\n  height: auto;\n  flex-shrink: 0;\n}\n\n.countryName {\n  flex: 1;\n  font-size: 14px;\n}\n\n.dialCodeText {\n  font-size: 13px;\n  color: #8c8c8c;\n  margin-left: auto;\n}\n\n/**\n * Dial code minimal (displayed in select box)\n */\n\n.dialCodeMinimal {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.flagImageSmall {\n  width: 18px;\n  height: auto;\n  flex-shrink: 0;\n}\n\n.dialCodeValue {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/**\n * Responsive adjustments\n */\n\n@media (max-width: 768px) {\n  .wrapper {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .dialCodeSelect {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `phone-number-module__wrapper--IQeyY`,
	"dialCodeSelect": `phone-number-module__dialCodeSelect--lwWi0`,
	"disabled": `phone-number-module__disabled--zpf6T`,
	"phoneInput": `phone-number-module__phoneInput--Qn9Ck`,
	"selectField": `phone-number-module__selectField--GiTXg`,
	"inputField": `phone-number-module__inputField--uD0tI`,
	"dialCodeOption": `phone-number-module__dialCodeOption--Te0rj`,
	"flagImage": `phone-number-module__flagImage--VS2Rg`,
	"countryName": `phone-number-module__countryName--cyt8P`,
	"dialCodeText": `phone-number-module__dialCodeText--oQpb6`,
	"dialCodeMinimal": `phone-number-module__dialCodeMinimal--vdJlY`,
	"flagImageSmall": `phone-number-module__flagImageSmall--Ae2TD`,
	"dialCodeValue": `phone-number-module__dialCodeValue--Mw3_b`
};
export default ___CSS_LOADER_EXPORT___;
